import React from 'react'
import { Icon, Popup } from 'semantic-ui-react'
import { REVIEWED_COLUMN_INFO_MESSAGE } from '../constants'

export const generateDynamicLabReportColumns = (columns, listStyle, consumerTitle) => {
  let tempColumns = []

  columns.map((partnerColumn) => {
    try {
      const parsedPartnerColumn = JSON.parse(partnerColumn)

      const isColumnActive = parsedPartnerColumn?.is_active ?? false
      const columnKey = parsedPartnerColumn?.column_key ?? null

      if (isColumnActive) {
        switch (columnKey) {
          case 'patient_name':
            tempColumns.push({
              name: consumerTitle === 'Client' ? 'Patient Name' : consumerTitle,
              className: `${listStyle.user} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'dob':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // DOB
              className: `${listStyle.accession} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'filler_id':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Accession #
              className: `${listStyle.accession} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'short_id':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Order ID
              className: `${listStyle.orderid} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'name':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Report Name
              className: `${listStyle.reportName} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'provider_name':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Provider Name
              className: `${listStyle.organization} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'ordered_date':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Ordered Date
              className: `${listStyle.ordered} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'report_date':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Ordered Date
              className: `${listStyle.ordered} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'status':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Status
              className: `${listStyle.status} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'reviewed':
            tempColumns.push({
              name: (
                <>
                  {parsedPartnerColumn.column_name}
                  <Popup trigger={<Icon name="info circle" />} content={REVIEWED_COLUMN_INFO_MESSAGE} basic />
                </>
              ),
              className: `${listStyle.reviewed} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'viewed':
            tempColumns.push({
              name: (
                <>
                  {parsedPartnerColumn.column_name}
                  <Popup
                    trigger={<Icon name="info circle" />}
                    content={`Viewed: the timestamp when the ${consumerTitle.toLowerCase()} opens the lab report for the first time.`}
                    basic
                  />
                </>
              ),
              className: `${listStyle.viewed} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'trending':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Trending
              className: `${listStyle.trending} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'lab_report_pdf':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Lab Report
              className: `${listStyle.labReport} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break
          case 'place_order':
            tempColumns.push({
              name: parsedPartnerColumn.column_name, // Place Order
              className: `${listStyle.orderLab} ${listStyle.th}`,
              code: columnKey,
              isActive: isColumnActive,
            })
            break

          default:
            break
        }
      }
    } catch (error) {
      console.error('Invalid JSON:', error)
      return null
    }
  })

  return tempColumns
}
